// https://www.color-name.com/hex/FFDC19

// ['smoke', 'whitesmoke'],
// ['color-gray', 'gray'],
// ['$blue-before-hover', '$blue-neutral'],

export const figmaStyleColors = [
    ['Primary/White', '#FFFFFF'], // ['White', '#FFFFFF', '15%', '25%'],
    ['Primary/DarkGray', '#656565', 'review'], // ['Granite Gray', '#656565', '3%'],
    ['Primary/Navy', '#001952', 'review'], // ['Oxford Blue', '#001952', '25%', '5%'], // ['Oxford Blue', '#011954'],
    ['Primary/Charcoal', '#333333', 'review'], // ['Dark Charcoal', '#333333', '10%', '25%'],
    ['Neutral/Fog', '#F8F7F9'],
    ['Extended/Red-Error', '#E02924'], // ['Permanent Geranium Lake', '#E02924'],
    ['Tint/Blue', '#E8FAFE'],
    ['Neutral/Chalk', '#F2F2F2'], //  ['Anti-Flash White', '#F2F2F2'],
    ['Neutral/Pastel', '#EBF1FF'],
    ['Tint/Green', '#E9FDF2'],
    ['Extended/Green-Success', '#007500'],
    ['Tint/Red', '#FBEEEC'],
    ['Tint/Yellow', '#FDFBE8'],
]
export const workInProgressColors = [
    ['Chinese Blue', '#395B99'],
    ['UCLA Blue', '#4C699E'],
    ['Ruddy Brown', '#B75527'],
    ['Anti-Flash White', '#F2F4F6']
]
export const listOfColorsShort = [
    ['Aero Blue', '#C3F4EB'],
    ['American Blue', '#2F4370'],
    ['Argent', '#C1C1C1', '50%'],
    ['Beer', '#FF8C1D'],
    ['Black', '#000000'],
    ['Blood Red', '#610505'],
    ['Blue Yonder', '#5D76A5'],
    ['Blue', '#0303F1'],
    ['Bright Gray', '#EBEBEB'],
    ['Bright Gray', '#EBEFF6'],
    ['Bubbles', '#E8F9FF'],
    ['Cerulean Blue', '#2C60C0'],
    ['Chinese Pink', '#E0789C', '15%'],
    ['Cool Black', '#00205B', '5%'],
    ['Cosmic Latte', '#FFFFE8'],
    ['Cultured', '#F5F5F5', '50%'],
    ['Dark Khaki', '#D0B56F'],
    ['Diamond', '#B9EDFF'],
    ['Ferrari Red', '#ED1A02'],
    ['Field Drab', '#786025'],
    ['Folly', '#FF004D'],

    ['Green Sheen', '#71C2B4'],
    ['Harlequin', '#25FF00'],
    ['Islamic Green', '#03A403'],
    ['Light Cyan', '#E3FCF7'],
    ['Light Green', '#7BF993'],
    ['Light Silver', '#D8D8D8'],
    ['Linen', '#F8F4E9'],
    ['Magic Mint', '#9BF1E1'],
    ['Manatee', '#9898AF'],
    ['Misty Rose', '#FFE8E8'],
    ['Myrtle Green', '#2F7B6E'],
    ['Naples Yellow', '#F8E165'],

    ['Pastel Red', '#FC6666'],
    ['Platinum', '#E2E2E2'],
    ['Platinum', '#E5E5E5', '25%', '50%'],
    ['Platinum', '#E6E6E6'],
    ['Purple (X11)', '#B31BF0'],
    ['Shocking Pink', '#F805BF'],
    ['Silver Sand', '#C4C4C4', '0%'],
    ['Snow', '#FFF7F7'],
    ['Space Cadet', '#14215B'],
    ['Spanish Gray', '#979797'],
    ['Spanish Gray', '#999999'],
    ['Venetian Red', '#D80F0F'],
    ['Water', '#D0F3FF'],
]

export const listOfColorsLong = [
    ['Anti-Flash White', '#EAF6F4'],
    ['Anti-Flash White', '#F2F3F6'],
    ['Azureish White', '#DFE7F6'],
    ['Bright Yellow (Crayola)', '#FFA826'],
    ['Brilliant Azure', '#33B2FD'],
    ['Caribbean Green', '#08BC9C'],
    ['Chinese Silver', '#CCCCCC'],
    ['Dark Pastel Blue', '#7792C6', '10%'],
    ['Deep Green-Cyan Turquoise', '#1F6D60'],
    ['Deep Green-Cyan Turquoise', '#217465'],
    ['Electric Orange', '#FF3400'],
    ['Indigo (Rainbow)', '#263B6C'],
    ['Lavender Indigo', '#9747FF'],
    ['Light Cobalt Blue', '#9393F0'],
    ['Light Hot Pink', '#FFABDF'],
    ['Metallic Sunburst', '#967A33'],
    ['Metallic Yellow', '#FFDC19'],
    ['Pale Robin Egg Blue', '#8BE8D7'],
    ['Violets Are Blue', '#7B61FF'],
    ['Vivid Mulberry', '#C006E3'],
]
export const newFigmaValues = [
    ['Periwinkle (Crayola)', '#C6D5EF', 'diff'],
    ['Anti-Flash White', '#EFF0F7', 'diff'],
    ['Cultured', '#F4F6F8', 'diff'],
    ['Ghost White', '#F5F8FF', 'diff'],
    ['Lavender Pink', '#F8B1CA', 'diff'],
    ['Lavender Blush', '#FAEBF0', 'diff'],
    ['Coral Red', '#FB4341', 'diff'],
    ['Lavender Blush', '#FCF0F5', 'diff'],
    ['Old Lace', '#FCF5E8', 'diff'],
]

export const percentsPreviAlpha = ['0%', '3%', '5%', '15%', '20%', '25%', '50%', '100%', '90%'] // items after 100% are not designer defaults.

export const percentsToHexAlpha = ['00', '08', '0d', '26', '33', '40', '80', '', 'e6'] // use hexAlpha becuase opacity css property messes up layout stack
// const morePercentIdeas = ['60%', '75%', '80%', '90%', '90%', '95%']


const _foundationColors = [
    ["Extended/Burnt-WarningAttn", "#B85300"],
    ["Extended/Green-Success", "#007500"],
    ["Extended/LightBurnt", "#FFF2DE"],
    ["Extended/LightGreen", "#EFFAEC"],
    ["Extended/LightRed", "#FFF0F0"],
    ["Extended/Red-Error", "#E02924"],
    ["Neutral/Chalk", "#F2F2F2"],
    ["Neutral/Fog", "#F8F7F9"],
    ["Neutral/Heather", "#EFF0F7"],
    ["Neutral/Ice", "#F5F8FF"],
    ["Neutral/Pastel", "#EBF1FF"],
    ["Neutral/Steel", "#CCCCCC"],
    ["Primary/Charcoal", "#333333"],
    ["Primary/DarkGray", "#656565"],
    ["Primary/Navy", "#001952"],
    ["Primary/White", "#FFFFFF"],
    ["Primary/Yellow", "#FFD405"],
    ["Secondary/Blue", "#73EAFF"],
    ["Secondary/Green", "#A9F4CD"],
    ["Secondary/Orange", "#F39A0C"],
    ["Secondary/Pink", "#F8B1CA"],
    ["Secondary/Red", "#FB4341"],
    ["Tint/Blue", "#E8FAFE"],
    ["Tint/Green", "#E9FDF2"],
    ["Tint/Orange", "#FCF5E8"],
    ["Tint/Pink", "#FCF0F5"],
    ["Tint/Red", "#FBEEEC"],
    ["Tint/Yellow", "#FDFBE8"],
]
